"use client";

import { useEffect } from "react";

interface Props {
  font?: string;
}

export const LoadFonts = ({ font }: Props) => {
  useEffect(() => {
    if (!font || typeof document === "undefined") return;

    const formattedFont = font.replace(/\s+/g, "+");
    const weights = [300, 400, 500, 600, 700];
    const href = `https://fonts.googleapis.com/css2?family=${formattedFont}:wght@${weights.join(";")}&display=swap`;
    const id = `gf-${formattedFont}`;

    // Preconnects (once)
    const ensurePreconnect = (url: string, id: string) => {
      if (document.getElementById(id)) return;
      const link = document.createElement("link");
      link.id = id;
      link.rel = "preconnect";
      link.href = url;
      link.crossOrigin = "anonymous";
      document.head.appendChild(link);
    };

    ensurePreconnect("https://fonts.googleapis.com", "gf-preconnect-api");
    ensurePreconnect("https://fonts.gstatic.com", "gf-preconnect-static");

    // Stylesheet (once per font)
    if (!document.getElementById(id)) {
      const link = document.createElement("link");
      link.id = id;
      link.rel = "stylesheet";
      link.href = href;
      link.crossOrigin = "anonymous";
      document.head.appendChild(link);
    }
  }, [font]);

  return null;
};
